import { resetImageZoom } from '../imageZoom.js'

const addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
    const togglePrevNextBtnsState = () => {
        if (emblaApi.canScrollPrev()) {
            prevBtn.removeAttribute('disabled')
        } else {
            prevBtn.setAttribute('disabled', 'disabled')
        }

        if (emblaApi.canScrollNext()) {
            nextBtn.removeAttribute('disabled')
        } else {
            nextBtn.setAttribute('disabled', 'disabled')
        }
    }

    emblaApi
        .on('init', togglePrevNextBtnsState)
        .on('select', togglePrevNextBtnsState)
        .on('reInit', togglePrevNextBtnsState)

    return () => {
        prevBtn.removeAttribute('disabled')
        nextBtn.removeAttribute('disabled')
    }
}

export const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
    const scrollPrev = () => {
        resetImageZoom()
        emblaApi.scrollPrev()
    }
    const scrollNext = () => {
        resetImageZoom()
        emblaApi.scrollNext()
    }
    prevBtn.addEventListener('click', scrollPrev, false)
    nextBtn.addEventListener('click', scrollNext, false)

    const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(emblaApi, prevBtn, nextBtn)

    return () => {
        removeTogglePrevNextBtnsActive()
        prevBtn.removeEventListener('click', scrollPrev, false)
        nextBtn.removeEventListener('click', scrollNext, false)
    }
}
